import { FLIGHT_TOTAL_ROW_ID } from '../types/flights.types.js';

export const LOADING_STATE = 'loading';

export const LOADING_FLIGHT = {
  id: LOADING_STATE,
  dateFrom: '',
  dateTo: '',
  name: '',
  budget: '',
  activityId: '',
  updatedAt: '',
  createdAt: '',
  updatedBy: 0,
  createdBy: 0,
  minDate: '',
  maxDate: '',
};

export const LOADING_TOTALS = {
  id: FLIGHT_TOTAL_ROW_ID,
  dateFrom: LOADING_STATE,
  dateTo: LOADING_STATE,
  name: LOADING_STATE,
  budget: LOADING_STATE,
};
